import * as React from "react";
import { useContext } from "react";
import { toast } from "react-toastify";
import PageMenuItem from "../../../../Layout/PageMenu/PageMenuItem";
import { EditProjectContext } from "../../EditProjectContext";
import getSpdrsForList from "../../LeftSide/InboundTab/GetSpdrsForList";
import { RouteEditTab } from "../../RouteEditTab";
import { setAllLtlBidpacks } from "./SetAllLtlBidpacks";
import { setAllShipFrequencies } from "./SetAllShipFrequencies";
import { setAllActiveLtlRoutings } from "./SetAllActiveLtlRoutings";
import { ProjectState } from "../../../ViewModel/ProjectState";
import { areEveryPipelinesChanged } from "./AreEveryPipelinesChanged";
import getPdsrsForList from "../../LeftSide/ReturnTab/GetPdsrsForList";
import { LtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScopeProps } from "./isLtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope";

type Props = {
  disabled?: boolean;
};

export const AddAllActiveRoutingsButton = ({
  disabled,
  isLtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope,
}: Props & LtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScopeProps) => {
  const editProjectContext = useContext(EditProjectContext);
  const { project, stopDataOfSpdrsOrPdsrs } = editProjectContext;

  const onAddAllActiveRoutingsButtonClick = async () => {
    const spdrsOnThisProjectLTL = getSpdrsForList(
      RouteEditTab.Ltl,
      project.SpdrsOnThisProject,
      project.FTLRoutes
    );
    const pdsrsOnThisProjectLTL = getPdsrsForList(
      RouteEditTab.Ltl,
      project.PdsrsOnThisProject,
      project.FTLRoutes
    );
    const spdrIds = spdrsOnThisProjectLTL?.map((x) => x.SpdrId);
    const pdsrIds = pdsrsOnThisProjectLTL?.map((x) => x.PdsrId);

    const hasRoutings = await toast.promise(
      setAllActiveLtlRoutings(editProjectContext, spdrIds, pdsrIds),
      {
        pending: "Loading of Active Routings",
        error: "Could not retrieve active Routings",
      }
    );
    if (!hasRoutings) {
      toast("No active Routings found", {
        type: "info",
      });
    } else {
      toast("Active Routings added", { type: "success" });
      await setAllLtlBidpacks(editProjectContext);
      await setAllShipFrequencies(editProjectContext);
    }
  };

  function isButtonDisabled(): boolean {
    if (project.State !== ProjectState.Sandbox) {
      return true;
    }
    if (stopDataOfSpdrsOrPdsrs.length !== 0) {
      return true;
    }
    if (!project.ltlPipelines) {
      return true;
    }

    return areEveryPipelinesChanged(project.ltlPipelines, stopDataOfSpdrsOrPdsrs, project)
      ? true
      : project.ltlPipelines.some((p) => (p.routing?.length || 0) > 0);
  }

  return (
    <PageMenuItem
      align="right"
      color="primary"
      type="button"
      onClick={onAddAllActiveRoutingsButtonClick}
      disabled={disabled || isButtonDisabled() || isLtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope}
    >
      Add All Active Routings
    </PageMenuItem>
  );
};
